import {
  RegisterAcceso,
  RegisterQRAcceso,
  RequestEnvioWhatsapp,
  RequestSaveMediosContacto,
  RequestVerifyQRCode,
  ResponseDataUser,
  ResponseEdificios,
  ResponseLstDiscapacidades,
  ResponseLstDiscapacidadesW,
} from "interfaces/accesoEdificios/accesoEdificiosInterface";
import { accesoAPI } from "../../api/tribunalAPi";

export const getJuzgadosEdificiosService = async () => {
  let url = "personas-edificios/obtener/edificios";
  return await accesoAPI.get<ResponseEdificios>(url);
};

export const getDatosUsuarioCurpService = async (curp: string) => {
  let url = `personas-edificios/obtener/datos-usuarios-curp?curp=${curp}`;
  return await accesoAPI.get<ResponseDataUser>(url);
};

export const postAccesoEdificiosService = async (body: RegisterAcceso) => {
  let url = `personas-edificios/guardar/registro-genera-codigo`;
  return await accesoAPI.post<any>(url, body);
};

export const getCodigoQRService = async (curp: string) => {
  let url = `personas-edificios/obtener/codigosqr-generados?curp=${curp}&qrCodificado=1`;
  return await accesoAPI.get<RegisterQRAcceso>(url);
};

export const getCodigoQRDownloadService = async (cveAcceso: string) => {
  let url = `personas-edificios/obtener/descargar-pdfqr?claveIdentificadorQR=${cveAcceso}`;
  return await accesoAPI.get<any>(url, { responseType: "arraybuffer" });
};

export const getDatosQREscaneadoService = async (cveAcceso: string) => {
  let url = `personas-edificios/obtener/datos-codigoqr?claveIdentificadorQR=${cveAcceso}`;
  return await accesoAPI.get<any>(url);
};

export const getDiscapacidadesService = async () => {
  let url = `generales/obtener/discapacidades`;
  return await accesoAPI.get<ResponseLstDiscapacidades | ResponseLstDiscapacidadesW>(url);
};

export const postEnvioWhatsapp = async (body: RequestEnvioWhatsapp) => {
  let url = `generales/enviar/enviar-whatsapp`;
  return await accesoAPI.post<any>(url, body);
};

export const postenvioCorreo = async (body: RequestEnvioWhatsapp) => {
  let url = `generales/enviar/enviar-correo`;
  return await accesoAPI.post<any>(url, body);
};

export const verifyQRCodeService = async (params: RequestVerifyQRCode) => {
  let url = `personas-edificios/guardar/registro-tribunal-codigo`;
  return await accesoAPI.post<any>(url, params);
};

export const saveMediosContactoService = async (
  params: RequestSaveMediosContacto
) => {
  let url = `generales/guardar/salva-medios-contacto`;
  return await accesoAPI.post<any>(url, params);
};

export const getSubDiscapacidadesService = async (idDiscapacidad: number) => {
  let url = `generales/obtener/subdiscapacidades?cveTipoDiscapacidad=${idDiscapacidad}`;
  return await accesoAPI.get<any>(url);
};

export const postDiscapacidades = async (request: any) => {
  let url = `generales/guardar/guardar-discapacidades-personas`;
  return await accesoAPI.post<any>(url, request);
};

export const postIdentificaciones = async (request: any) => {
  let url = `generales/guardar/adjunta-identificaciones`;
  return await accesoAPI.post<any>(url, request);
};
